import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import { ResultCardDetail } from './model.ts'
import s from './styles.module.scss'

interface Props {
  item: ResultCardDetail
}

export const ResultCardDetails = ({ item }: Props) => {
  return (
    <div className={s.rideDetails}>
      <AppIcon
        id={AllIcons.CIRCLE_LINE}
        width={8}
        height={70}
        className={s.line}
      />

      <div className={s.rideTime}>
        <div className={s.rideTimeLine}>
          <div className={s.rideTimeCol}>
            <p className={clsx('medium-14', s.time)}>{item?.departure?.time}</p>
            <p className={clsx('regular-12', s.grey)}>
              {item?.departure?.date}
            </p>
          </div>
          <div className={clsx(s.rideTimeCol, s.rightSide)}>
            <p className={clsx('medium-14', s.time)}>{item?.departure?.city}</p>
            <p className={clsx('regular-12', s.grey)}>
              {item?.departure?.station}
            </p>
          </div>
        </div>
        <div className={s.rideTimeLine}>
          <div className={s.rideTimeCol}>
            <p className={clsx('medium-14', s.time)}>{item?.arrival?.time}</p>
            <p className={clsx('regular-12', s.grey)}>{item?.arrival?.date}</p>
          </div>
          <div className={clsx(s.rideTimeCol, s.rightSide)}>
            <p className={clsx('medium-14', s.time)}>{item?.arrival?.city}</p>
            <p className={clsx('regular-12', s.grey)}>
              {item?.arrival?.station}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
